import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useField } from "formik";
import moment from "moment";

export const DatePickerWrapper = (props) => {
  const { name, onChange, ...otherProps } = props;
  const [field, meta, helpers] = useField(name);
  return (
    <DatePicker
      {...otherProps}
      format="DD/MM/YYYY"
      slotProps={{
        ...otherProps.slotProps,
        textField: {
          helperText: meta.error,
          error: !!meta.error,
          ...(otherProps.slotProps?.textField || {}),
        },
      }}
      value={moment(field.value)}
      onChange={(value) => {
        helpers.setValue(value ? value.toISOString() : null);
        if (onChange) {
          onChange(value);
        }
      }}
    />
  );
};
